var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header",null,{"toggle":_vm.toggle,"locations":_vm.locations}),(_vm.geojson)?_c('locations-map',{attrs:{"locations":_vm.locations,"geojson":_vm.geojson},on:{"click":_vm.toggle}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }